export default {
    props: {
        bill: {
            type: Object,
            required: true,
        },
        bills: {
            type: Array,
            required: false,
        },
        housemates: {
            type: Number,
            required: true,
        },
        selected: {
            type: Boolean,
            default: false,
        },
        hidePrices: {
            type: Boolean,
            default: false,
        },
        packageBill: {
            type: Object,
            required: false,
            default: null,
        },
    },

    methods: {
        toggle(id) {
            this.$emit("toggle", id);
        },

        getPricePerHousemate() {
            return this.bill.prices.find(
                (price) => price.housemates === this.housemates
            ).price_per_housemate;
        },
    },
};
